import { render, staticRenderFns } from "./TicketReply.vue?vue&type=template&id=4c2ee513&"
import script from "./TicketReply.vue?vue&type=script&lang=js&"
export * from "./TicketReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2ee513')) {
      api.createRecord('4c2ee513', component.options)
    } else {
      api.reload('4c2ee513', component.options)
    }
    module.hot.accept("./TicketReply.vue?vue&type=template&id=4c2ee513&", function () {
      api.rerender('4c2ee513', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Support/TicketSingle/TicketReply.vue"
export default component.exports